export default "__VITE_ASSET__cMH$3Y2u__"